import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-please-wait',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './please-wait.component.html',
  styleUrl: './please-wait.component.scss'
})
export class PleaseWaitComponent {
  @Input() titleKey = 'login.PleaseWait';
  @Input() subtitleKey = 'login.ProcessingRequest';
  @Input() title?: string;
  @Input() subtitle?: string;

  @Input() portalUrl = 'https://p2-innovate.com/offering/zum-connect-customer-portal/';
  @Input() showFooter = true;
}
